import VideoPlayer from '@components/common/VideoPlayer'
import { Container } from '@components/ui'
import ReactPlayer from 'react-player'
interface Props {
  slice: any
}

const VideoBlock = ({ slice }: Props) => {
  const primary = slice?.primary
  const videoURl = primary?.video?.url || primary?.video_url
  const title = primary?.title
  const description = primary?.description
  const linkUrl = primary?.link
  const linkText = primary?.link_text
  const textAlign: 'left' | 'center' = primary?.text_align
  const uploadedThumbnail = primary?.thumbnail
  const aspectRatio = primary?.aspect_ratio

  if (!ReactPlayer.canPlay(videoURl) || !videoURl) return <></>
  return (
    <div className="bg-white">
      <Container>
        <div className="flex flex-col py-12 md:py-20">
          <VideoPlayer
            videoURl={videoURl}
            thumbnail={uploadedThumbnail?.url}
            title={title}
            description={description}
            linkUrl={linkUrl}
            linkText={linkText}
            textAlign={textAlign}
            aspectRatio={aspectRatio}
          />
        </div>
      </Container>
    </div>
  )
}

export default VideoBlock
